import React from "react";
import { Card, CardContent, Typography, Box, Grid, CircularProgress } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { transformChequeSummary } from ".";

interface WSdonoutProps {
  chequeSummary: Record<string, number> | null;
  loading?: boolean;
}

const WSdonout: React.FC<WSdonoutProps> = ({ chequeSummary, loading }) => {
  const data = transformChequeSummary(chequeSummary);

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: 3,
        padding: 2,
        maxWidth: 500,
        margin: "auto",
      }}
    >
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Cheque Status Summary
        </Typography>

        {loading ? <Box
          sx={{
            width: "100%",
            height: 320,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="success" />
        </Box> : <>
          <Box sx={{ width: "100%", height: 210 }}>
            <ResponsiveContainer>
              <PieChart>
                <Tooltip
                  contentStyle={{
                    borderRadius: "10px",
                    border: "1px solid #e5e7eb",
                  }}
                  formatter={(value: number, name: string) => [`${value}`, name]}
                />

                <Pie
                  data={data}
                  innerRadius={70}
                  outerRadius={100}
                  paddingAngle={3}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </Box>

          <Grid container spacing={2} mt={2}>
            {data.map((item, index) => (
              <Grid item xs={6} key={index}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      backgroundColor: item.color,
                    }}
                  />
                  <Typography variant="body2">{item.name}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </>}
      </CardContent>
    </Card>
  );
};

export default WSdonout;